<template lang="pug">
  .routing-tabs
    Tabs.tab-select(
      :align="align"
      :sticky="sticky"
      :title="title"
      :theme="theme"
      :modelValue="activeTab"
      @update:modelValue="changeTab"
      :tabs="tabs.map(t => t.title)"
    )
</template>
<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRogue } from '../../js/rogue'

type RoutingTab = {
  title: string,
  url: string,
}

const props = withDefaults(defineProps<{
  tabs?: RoutingTab[],
  theme?: string | null,
  sticky?: boolean,
  align?: 'none' | 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch' | null,
  title?: string | null,
}>(), {
  tabs   : () => [],
  theme  : null,
  sticky : false,
  align  : null,
  title  : null,
})

const rogue = useRogue()

const activeTab = computed(() => {
  const aTab = props.tabs.find(tab => {
    // check if the tab url isn't the root and therefore could have sub tabs
    const subTabCheck = tab.url.substring(1)
    if (subTabCheck.indexOf('/') > 0) {
      return rogue?.router?.currentRoute.value?.path.startsWith(tab.url)
    }

    return tab.url === rogue?.router?.currentRoute.value?.path
  })

  return (aTab || {}).title
})

onMounted(() => {
  loadAllTabContent()
})

async function loadAllTabContent() {
  props.tabs.forEach(async tab => {
    if (rogue) {
      const cms = rogue.getCms()
      if (!Object.hasOwnProperty.call(cms, tab.url.substring(1))) {
        const routeData: { cmsId?: number } = await rogue.fetch(`/svc_route/route?url=${tab.url}`)
        const { cmsId } = routeData

        if (cmsId) {
          rogue.setCmsIdForUrl(tab.url, cmsId)
          await rogue.loadCms(cmsId)
        }
      }
    }
  })
}

function changeTab(tabName: string) {
  // Go to the route of the new tab
  const tab = props.tabs.find(t => t.title === tabName)

  if (tab) {
    rogue?.router?.push(tab.url)
  }
}
</script>
<style lang="scss" scoped>
@include mobile() {
  .tab-select {
    z-index: 2;

    :deep(.tab-title) {
      white-space: nowrap;
    }
  }
}

.tab-title {
  font-size: $size-l;
}

:deep(.tab-header) {
  margin-bottom: 0;
}

.inactive {
  display: none;
}
</style>
